import meta from "src/utils/meta";
import request from "superagent";

export const _recordShiftTime = async (shiftId: string, actionTime: string, action: string) => {
  const data = {
    stage: action,
    location: [73.0702553, 33.6717341],
    timecard: "",
    locationType: "LIVE",
    appType: "WEB",
    connectivityMode: "ONLINE",
    actionTime,
  };

  let actionRes = await request
    .post(`${meta().api ?? ""}/api/testHelpers/shift/recordTime/${shiftId}`)
    // .set(await getAuthHeader())
    .send(data);
  actionRes = await actionRes;
  return actionRes;
};
